export function isNode(): boolean {
  /**
   * Polyfills of 'process' might set process.browser === true
   *
   * See:
   * https://github.com/webpack/node-libs-browser/blob/master/mock/process.js#L8
   * https://github.com/defunctzombie/node-process/blob/master/browser.js#L156
   **/
  return (
    Object.prototype.toString.call(
      typeof process !== 'undefined' ? process : 0
    ) === '[object process]'
  );
}

export function isReactNative(): boolean {
  return (
    typeof window !== 'undefined' &&
    'navigator' in window &&
    'product' in window.navigator &&
    window.navigator.product === 'ReactNative'
  );
}

export function getNodeVersion(): string {
  return process.versions && process.versions.node
    ? `v${process.versions.node}`
    : process.version;
}

export function getWindow(): Window {
  return window;
}

export function noop(): undefined {
  return undefined;
}
